import React, { useState, useEffect } from 'react';
import './Navigation.css';

const Navigation = ({ currentSection }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const sections = ['Início', 'Sobre', 'Skills', 'LockIt', 'Monely', 'Motion', 'Contato'];

  const scrollToSection = (index) => {
    const windowHeight = window.innerHeight;
    window.scrollTo({
      top: windowHeight * index,
      behavior: 'smooth'
    });
  };

  return (
    <nav className={`navigation ${isVisible ? 'visible' : ''}`}>
      <div className="nav-logo">RC</div>
      <ul className="nav-menu">
        {sections.map((section, index) => (
          <li key={index}>
            <button
              className={currentSection === index ? 'active' : ''}
              onClick={() => scrollToSection(index)}
            >
              {section}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navigation;
